import script from "./ServiceDetailSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailSkeleton.vue?vue&type=style&index=0&id=a27cfdf0&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a27cfdf0"]])

export default __exports__